import { type IntegrationResponse, IntegrationType } from '@shared/api/rest/integrations';
import { IntegrationCard } from './integrationCard';
import { NoData } from '@shared/widgets';

interface Props {
  list: IntegrationResponse[];
  integration?: IntegrationType;
}

export const IntegrationList = (props: Props) => {
  return (
    <>
      {props.list.length > 0 ? (
        <div className='flex flex-wrap'>
          <div className='w-full max-w-[330px] flex-none'>
            {props.list.map((integration, idx) => (
              <IntegrationCard key={idx} integration={integration} />
            ))}
          </div>
        </div>
      ) : (
        <NoData />
      )}
    </>
  );
};
